import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SliceKeys } from "@evr/constant";
import { tablePaginationInitialValue } from "@evr/constant";
import { RootState } from "@evr/store";
import { SearchColumn } from "@evr/types";
import { getTableSortColumn, queryBuilder } from "@evr/utils";

export const LezSlice = createSlice({
  name: SliceKeys.LEZS,
  initialState: { pagination: tablePaginationInitialValue },
  reducers: {
    setLezPageIndex: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = action.payload;
    },
    setLezSearchColumn: (state, action: PayloadAction<SearchColumn>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.search[action.payload.column] = action.payload;
    },
    clearLezSearchColumn: (state, action: PayloadAction<string>) => {
      const { [action.payload]: deleteItem, ...otherSearchItems } = state.pagination.search;
      state.pagination.search = otherSearchItems;
    },
    setLezSortColumn: (state, action: PayloadAction<string>) => {
      const { column, type } = state.pagination.sort;
      state.pagination.sort = getTableSortColumn(column, action.payload, type);
    },
  },
});

export const { setLezPageIndex, setLezSearchColumn, setLezSortColumn, clearLezSearchColumn } =
LezSlice.actions;

export const selectLezsQuery = createSelector(
  (state: RootState) => state.lezs.pagination,
  ({ pageSize, pageIndex, search, sort }) => queryBuilder(pageSize, pageIndex, search, sort),
);

export const selectLezsPagination = createSelector(
  (state: RootState) => state.lezs.pagination,
  ({ totalPages, pageIndex, sort, search }) => ({ totalPages, pageIndex, sort, search }),
);
export default LezSlice.reducer;
